import {MetricCard} from '@tinct/web-components';

interface DashboardMetricsProps {
  assetsUrl: string;
  totalCampaignsCount: number;
  publishedCampaignsCount: number;
  pageVariantsCount: number;
  publishedPercentage: number;
  visitsCount: number;
  visitsVariation: number | null | undefined;
}

export function DashboardMetrics({
  assetsUrl,
  totalCampaignsCount,
  publishedCampaignsCount,
  pageVariantsCount,
  publishedPercentage,
  visitsCount,
  visitsVariation,
}: DashboardMetricsProps) {
  const formatVariation = (variation: number | null | undefined) => {
    if (variation === null || variation === undefined) return '';
    const sign = variation >= 0 ? '+' : '';
    return `${sign}${variation}% from previous period`;
  };

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      <MetricCard
        headerText="Campaign"
        icon={<img src={`${assetsUrl}/campaign.png`} alt={"Campaign"}/>}
        statisticText={String(totalCampaignsCount)}
        descriptionText={`${publishedCampaignsCount} active`}
        variant={totalCampaignsCount === 0 ? 'empty' : 'default'}
      />
      <MetricCard
        headerText="Active pages"
        icon={<img src={`${assetsUrl}/windows.png`} alt={"Windows"}/>}
        statisticText={String(pageVariantsCount)}
        descriptionText={`${publishedPercentage}% published`}
        variant={pageVariantsCount === 0 ? 'empty' : 'default'}
      />
      <MetricCard
        headerText="Visits"
        icon={<img src={`${assetsUrl}/target.png`} alt={"Target"}/>}
        statisticText={String(visitsCount)}
        descriptionText={formatVariation(visitsVariation)}
        variant={visitsCount === 0 ? 'empty' : 'default'}
      />
    </div>
  );
}
